module.exports = __webpack_public_path__ + "static/img/pic4.eb5b8db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/universityHall/images/pic4.jpg
// module id = HUrN
// module chunks = 0